// @flow

import React, { type Node } from 'react';
import { getQueryParamValueOrCry } from '../../../../../../commons/query-params';
import { Container } from '../../../../../../commons/look-and-feel/uber/atom/container';

export function SodexoWebview(): Node {
  return (
    <Container style={{background: 'white', height: '100%'}}>
      <iframe id={'sodexo-iframe'} src={getQueryParamValueOrCry('sodexo_url')} width={'100%'} height={'100%'} frameBorder="0"/>
    </Container>);
}
